import React, { forwardRef } from 'react';

import type { LinkProps } from 'react-router-dom';
import { Link } from 'react-router-dom';

/**
 * A simple wrapper around react-router's link to use in the "component" prop of Material-UI safely.
 * See https://material-ui.com/guides/composition/#caveat-with-prop-forwarding.
 */
export const RouterLink = forwardRef(function RouterLink(
  props: LinkProps,
  ref: React.Ref<HTMLAnchorElement>
): JSX.Element {
  return <Link ref={ref} {...props} />;
});
